var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.owner != null)?_c('div',[_c('individual-bank-details',{staticClass:"mt-2",attrs:{"owner":_vm.owner}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }